import React from 'react';

import styles from './DefaultOdontologiaView.module.scss';

const DefaultOdontologiaView = () => {
  return (
    <div className={styles.default_odontologia_view}>
      <p>
        Contamos con <strong>9 Centros Odontológicos propios</strong> de primer nivel para nuestros
        asociados: 5 en Capital Federal, 2 en Gran Buenos Aires, 1 en Neuquén y 1 en Salta.
      </p>
      <p>
        <strong>Los mismos cuentan con:</strong>
      </p>
      <ul>
        <li>Experimentados profesionales especializados en todas las ramas de la odontología.</li>
        <li>Tecnología de excelencia.</li>
        <li>Normas de Bioseguridad estrictamente controladas.</li>
        <li>Amplia red de prestadores de primer nivel profesional.</li>
      </ul>
      <p>
        Todos nuestros asociados cuentan con valores preferenciales y financiación en los
        tratamientos de prótesis, implantes dentales, tratamientos de ortodoncia y blanqueamiento
        dental cuando el plan de cobertura no lo contemple.
      </p>
    </div>
  );
};

export default DefaultOdontologiaView;
